import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { matchPathWithLocale } from "@faire/web/common/routing/react-utils";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";
import { BRAND_CONSOLIDATION_BLOCKED_PATHS } from "./utils";

export const useBrandConsolidationGate: IGateHook = () => {
  const modalType = useModalType();

  if (
    modalType === PromoModalType.BRAND_CONSOLIDATION_PROMO_MODAL &&
    !BRAND_CONSOLIDATION_BLOCKED_PATHS.some(
      (path) =>
        !!matchPathWithLocale(getWindowOrThrow().location.pathname, path)
    )
  ) {
    return PromoModalType.BRAND_CONSOLIDATION_PROMO_MODAL;
  }

  return undefined;
};
